import { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useTelegram } from '../context/TelegramContext'
import Header from '../components/Header'
import './AdminProductEdit.css'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api'

const AdminProductEdit = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { isAdmin, showAlert } = useTelegram()
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [categories, setCategories] = useState([])
  
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    price: '',
    old_price: '',
    category: '',
    in_stock: true
  })

  useEffect(() => {
    if (isAdmin !== true) {
      showAlert?.('Доступ запрещён')
      navigate('/')
      return
    }
    loadCategories()
    if (id !== 'add') {
      loadProduct()
    } else {
      setLoading(false)
    }
  }, [id, isAdmin])

  const loadCategories = async () => {
    try {
      const response = await fetch(`${API_URL}/categories`)
      const data = await response.json()
      if (data.success && data.categories) {
        setCategories(data.categories)
      }
    } catch (err) {
      console.error('Ошибка загрузки категорий:', err)
    }
  }

  const loadProduct = async () => {
    try {
      setLoading(true)
      const response = await fetch(`${API_URL}/products/${id}`)
      const data = await response.json()
      
      setFormData({
        name: data.name || '',
        description: data.description || '',
        price: data.price || '',
        old_price: data.old_price || '',
        category: data.category || '',
        in_stock: data.in_stock !== false
      })
    } catch (err) {
      console.error('Ошибка загрузки товара:', err)
      showAlert?.('Не удалось загрузить товар')
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    if (!formData.name || !formData.price || !formData.category) {
      showAlert?.('Заполните обязательные поля')
      return
    }

    try {
      setSaving(true)
      
      const url = id === 'add' 
        ? `${API_URL}/products`
        : `${API_URL}/products/${id}`
      
      const method = id === 'add' ? 'POST' : 'PUT'
      
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...formData,
          price: parseFloat(formData.price),
          old_price: formData.old_price ? parseFloat(formData.old_price) : null
        })
      })

      if (response.ok) {
        showAlert?.(id === 'add' ? 'Товар добавлен' : 'Товар обновлён')
        navigate('/admin/products')
      } else {
        showAlert?.('Ошибка сохранения товара')
      }
    } catch (err) {
      console.error('Ошибка сохранения:', err)
      showAlert?.('Ошибка сохранения товара')
    } finally {
      setSaving(false)
    }
  }

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }))
  }

  if (loading) {
    return (
      <div className="admin-product-edit">
        <Header title={id === 'add' ? 'Добавить товар' : 'Редактировать товар'} showBack={true} />
        <div className="loading">Загрузка...</div>
      </div>
    )
  }

  return (
    <div className="admin-product-edit">
      <Header title={id === 'add' ? 'Добавить товар' : 'Редактировать товар'} showBack={true} />
      
      <form className="product-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Название *</label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => handleChange('name', e.target.value)}
            placeholder="Введите название товара"
            required
          />
        </div>

        <div className="form-group">
          <label>Описание</label>
          <textarea
            value={formData.description}
            onChange={(e) => handleChange('description', e.target.value)}
            placeholder="Введите описание товара"
            rows="4"
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Цена * (₽)</label>
            <input
              type="number"
              value={formData.price}
              onChange={(e) => handleChange('price', e.target.value)}
              placeholder="0"
              required
              step="0.01"
            />
          </div>

          <div className="form-group">
            <label>Старая цена (₽)</label>
            <input
              type="number"
              value={formData.old_price}
              onChange={(e) => handleChange('old_price', e.target.value)}
              placeholder="0"
              step="0.01"
            />
          </div>
        </div>

        <div className="form-group">
          <label>Категория *</label>
          <select
            value={formData.category}
            onChange={(e) => handleChange('category', e.target.value)}
            required
          >
            <option value="">Выберите категорию</option>
            {categories.map(cat => (
              <option key={cat.id} value={cat.name}>
                {cat.emoji} {cat.name}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group checkbox-group">
          <label>
            <input
              type="checkbox"
              checked={formData.in_stock}
              onChange={(e) => handleChange('in_stock', e.target.checked)}
            />
            <span>В наличии</span>
          </label>
        </div>

        <div className="form-actions">
          <button 
            type="button" 
            className="btn-cancel"
            onClick={() => navigate('/admin/products')}
          >
            Отмена
          </button>
          <button 
            type="submit" 
            className="btn-save"
            disabled={saving}
          >
            {saving ? 'Сохранение...' : 'Сохранить'}
          </button>
        </div>
      </form>

      <div className="info-note">
        <strong>Примечание:</strong> Загрузка изображений пока доступна только через бот. 
        Используйте команду /admin в боте для загрузки фото.
      </div>
    </div>
  )
}

export default AdminProductEdit





